import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';
import { useGlassData } from './useGlassData';

const GlassStrength = ({ value, onChange, id = 'GlassStrength', label = 'Glass Strength', disabled = false, showPics = false, appliesTo = 'windows' }) => {
    const defaultValue = value?.value || '';
    const [selectedGlassStrength, setSelectedGlassStrength] = useState(defaultValue);
    const [showModal, setShowModal] = useState(false);
    const { getGlassStrength, loading, error } = useGlassData(appliesTo);

    const options = getGlassStrength();

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedGlassStrength(value?.value || '');
    }, [value]);

    // Trigger initial onChange once when options are loaded
    useEffect(() => {
        if (!loading && options.length > 0 && !selectedGlassStrength) {
            const defaultOption = options[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedGlassStrength(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, [loading, options]);

    const handleGlassStrengthChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedGlassStrength(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    if (error) {
        console.error('Error loading glass strength:', error);
    }

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedGlassStrength}
                onChange={handleGlassStrengthChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    options.map(option => (
                        <option key={option.id} value={option.value}>
                            {selectedGlassStrength === option.value ? `${option.label} ✔` : option.label}
                        </option>
                    ))
                )}
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/GlassStrength"
                imageName={selectedGlassStrength}
                width={200}
                height={250}
            />
        </div>
    );
};

export default GlassStrength;
